module.exports = __webpack_public_path__ + "img/symbol-diy-center.ce54126a.png";